<template>
  <div>
    <div v-if="playVideo" class="row no-gutters">
      <div class="col-12 text-center bg-black">
        <video id="videoSplash" ref="videoRef" autoplay class="bg-splash"
               muted="muted" poster="false">
          <source src="../assets/videos/splashVideo.mp4" type="video/mp4">

        </video>
      </div>
    </div>
    <div v-else>
      <NavBar id="navHeader" class="overflow-y-hidden"/>
      <v-main class=" overflow-y-hidden overflow-x-hidden">
        <div id="homePage" class="container-fluid">
          <HashtagsBar/>
          <div v-if="bannerLoading" class="row align-items-center">
            <div class="col-12 text-center pb-1">
              <v-skeleton-loader
                  class="mx-auto border"
                  height="150"
                  type="image"
                  width="100%"
              ></v-skeleton-loader>
            </div>
          </div>
          <div v-else class="row ">
            <div class="col-12 ">
              <div
                  v-if="banner !== null && banner !== undefined && banner.length > 0"
                  class="row"
                  dir="ltr">
                <carousel
                    :autoplay="true"
                    :dots="false"
                    :items="1"
                    :loop="false"
                    :margin="5"
                    :nav="false"
                    :rtl="true"
                    class="col-12 pt-0">
                  <div
                      v-for="item in banner"
                      :key="item.BanerID">
                    <a :href="item.Link" target="_blank">
                      <v-img
                          v-if="item.src !== null"
                          :src="$replaceHttps(item.FileUrl)"
                          class="rounded-lg border">

                      </v-img>
                    </a>
                  </div>
                </carousel>
              </div>
            </div>
          </div>
          <div v-if="postLoading" class="row align-items-center">
            <div class="col-12 text-center">
              <v-skeleton-loader
                  type="list-item-avatar, image, article"
              ></v-skeleton-loader>
            </div>
          </div>
          <div v-else class="row d-none d-sm-flex">
            <div v-if="DesktopPosts !== null && DesktopPosts !== undefined && DesktopPosts.length > 0" id="homeCarousel"
                 class="col-11"
                 dir="ltr">
              <carousel
                  :autoplay="false"
                  :dots="false"
                  :loop="true"
                  :margin="6"
                  :nav="false"
                  :responsive="{600:{items:2}
                                                ,1100:{items:3}}"
                  :rtl="true">
                <template slot="next">
                  <div class="next">
                    <v-btn class="primary-bg" icon large>
                      <i class="fa-solid fa-arrow-left white--text font24px"></i>
                    </v-btn>
                  </div>
                </template>
                <div
                    v-for="item in DesktopPosts"
                    :key="item.VendorSocialNetworkID"
                    class="bg-white rounded-lg p-2"
                    dir="rtl">
                  <PostCard :item="item"/>

                </div>
              </carousel>
            </div>
          </div>
          <div class="row d-flex d-sm-none">
            <div
                v-for="item in posts"
                :key="item.VendorSocialNetworkID"
                class="rounded-lg p-2 col-12 "
                dir="rtl">
              <PostCard :item="item"/>

            </div>
            <div v-observe-visibility="visibilityChanged" class="col-12">
              <div v-if="isVisible && this.pageIndex >1" class="row align-items-center">
                <div class="col-12 text-center">
                  <v-progress-circular
                      :size="50"
                      color="primary"
                      indeterminate
                  ></v-progress-circular>
                </div>
              </div>
            </div>
          </div>


        </div>
      </v-main>
      <v-overlay :value="showLoaderDialog">
        <div class="loading-spinner">
        </div>
      </v-overlay>
      <v-snackbar
          v-model="showResult"
          :multi-line="true"
          color="primary"
      >
        {{ text }}

        <template v-slot:action="{ attrs }">
          <v-btn v-bind="attrs" icon @click="showResult = false ">
            <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </div>

</template>
<script>
let _this = null

import carousel from "vue-owl-carousel";
import PostCard from "@/components/PostCard";
import NavBar from "@/components/NavBar";
import HashtagsBar from "@/components/HashtagsBar";


export default {
  name: "Home",
  metaInfo: {
    title: 'ایوان خانه-خانه ',
  },
  components: {
    HashtagsBar,
    NavBar,
    PostCard,
    carousel,
  },
  data: () => ({
    playVideo: true,
    showLoaderDialog: false,
    showResult: false,
    text: `نظر شما با موفقیت ثبت شد`,
    bannerLoading: true,
    banner: [],
    categoriesLoading: true,
    categories: [],
    productsList: [],
    hashtags: [],
    posts: [],
    DesktopPosts: [],
    postLoading: true,
    cycle: false,
    allHashtags: [],
    pageIndex: 0,
    pageSize: 10,
    show: true,
    isVisible: true,
    isShowSplash:false

  }),

  mounted() {
    _this = this
    if(!this.$store.getters.getIsShowSplash) {
      let video = document.getElementById("videoSplash");
      this.$refs.videoRef.play();
      setTimeout(function () {
        video.play();
        _this.playVideo = false;
        _this.$store.commit('setIsShowSplash', true)
      }, 2000);
    }else {
      this.playVideo = false;
    }
    this.$scrollTop(0)
    this.posts = []
    this.DesktopPosts = []
    this.getData();
    this.getHashtags();
    this.getProductList();

  },
  // watch:{
  //   '$store.getters.getProductList'(){
  //     if(this.$store.getters.getProductsList.length >0){
  //       this.getPosts()
  //     }
  //   }
  // },
  destroyed() {
    window.onscroll = undefined
    this.posts = []
    this.DesktopPosts = []
  },
  methods: {
    visibilityChanged(isVisible) {
      this.isVisible = isVisible
      if (isVisible && this.pageIndex >= 1) {

        this.getPosts()
      }
    },
    getData() {
      this.showLoaderDialog = true
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + 'Home', requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            let banners = json.BanerViewModel.filter(x => x.IsActive === true)
            this.banner = banners.filter(x => x.TypeBaner === 1)
            this.bannerLoading = false;
            this.showLoaderDialog = false;

          })
          .catch(error => console.log('error', error));
    },
    getHashtags() {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/GetHashTags", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.hashtags = json.filter(x => x.IsPopular === true)
            this.allHashtags = json
            this.categoriesLoading = false
          })
          .catch(error => console.log('error', error));
    },
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    getProductList() {
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Shopping/GetActiveProducts", requestOptions)
          .then(response => response.text())
          .then(result => {
            this.productsList = JSON.parse(result)
            this.getPosts()
          })
          .catch(error => console.log('error', error));
    },
    getPosts() {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("pageIndex", this.pageIndex);
      urlencoded.append("pageSize", "10");

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "SearchSocialNetwork/_List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = (JSON.parse(result).list).filter(x => x.IsActive === true)

            for (let i = 0; i < json.length; i++) {
              let postFiles = []
              postFiles.push({src: json[i].FileUrl, type: json[i].TypeStrucGallery})
              if (json[i].FileUrl2 !== null) {
                postFiles.push({src: json[i].FileUrl2, type: json[i].FileType2})
              }
              if (json[i].FileUrl3 !== null) {
                postFiles.push({src: json[i].FileUrl3, type: json[i].FileType3})
              }
              if (json[i].FileUrl4 !== null) {
                postFiles.push({src: json[i].FileUrl4, type: json[i].FileType4})
              }
              if (json[i].FileUrl5 !== null) {
                postFiles.push({src: json[i].FileUrl5, type: json[i].FileType5})
              }
              if (json[i].FileUrl6 !== null) {
                postFiles.push({src: json[i].FileUrl6, type: json[i].FileType6})
              }
              if (json[i].FileUrl7 !== null) {
                postFiles.push({src: json[i].FileUrl7, type: json[i].FileType7})
              }
              if (json[i].FileUrl8 !== null) {
                postFiles.push({src: json[i].FileUrl8, type: json[i].FileType8})
              }
              if (json[i].FileUrl9 !== null) {
                postFiles.push({src: json[i].FileUrl9, type: json[i].FileType9})
              }
              if (json[i].FileUrl10 !== null) {
                postFiles.push({src: json[i].FileUrl10, type: json[i].FileType10})
              }
              json[i].files = postFiles


              let allHashtags = this.allHashtags
              let selectedHashtags = json[i].SelectedHashTags
              let hashtags = []
              if (selectedHashtags !== null && selectedHashtags.length > 0) {
                for (let i = 0; i < selectedHashtags.length; i++) {
                  hashtags.push(allHashtags.find(x => x.HashTagID === selectedHashtags[i]))
                }
              }
              json[i].hashtags = hashtags


              let products = this.productsList

              let relatedProducts = []
              let selectedProducts = json[i].SelectedProducts
              if (selectedProducts !== null) {
                for (let i = 0; i < selectedProducts.length; i++) {
                  relatedProducts.push(products.find(x => x.VendorProductID === selectedProducts[i]))
                }
                for (let i = 0; i < relatedProducts.length; i++) {
                  relatedProducts[i].tip = relatedProducts[i].VendorProductTipViewModels[0]
                }
              }


              json[i].relatedProducts = relatedProducts


            }
            if (this.pageIndex === 0) {
              this.DesktopPosts = json
            }
            for (let i = 0; i < json.length; i++) {
              if (this.posts.find(x => x.VendorSocialNetworkID === json[i].VendorSocialNetworkID) === undefined) {
                this.posts.push(json[i])
              }

            }
            this.postLoading = false
            this.pageIndex++

          })
          .catch(error => console.log('error', error));
    },

  }
};
</script>

<style scoped>


</style>
